<ng-container *ngIf="data$ | async as data" class="backcolor">
    <header class="header">
      <div class="header-info">
        <div [style.backgroundColor]="data.headerColor" class="header-info-top">
          <div class="header-info-headers">
            <h3 [ngStyle]="{fontSize:fontSize}">
              {{ data.firstName }} {{data.lastName}}</h3>
            <div class="dot">&middot;</div>
            <h3 [ngStyle]="{fontSize:fontSize}">
              {{ data.companyName }}</h3>
          </div>
        </div>
      </div>
      <div class="header-logo">
        <div class="header-logo-img">
          <div class="img-container"
            [ngStyle]="{'background-image': 'url(' + data.companyLogoUrl + ')'}">
          </div>
          <!-- <img 
            *ngIf="data.companyLogoUrl" 
            [src]="data.companyLogoUrl" 
            alt="Real Estate Partners"> -->
        </div>
      </div>
    </header>
    <table class="offer-content-table">
      <thead>
        <tr>
          <td>
            <div class="header-space">&nbsp;</div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <main>
              <section class="summary-section">
                <h2>Offer Summary</h2>
  
                <table class="summary-table">
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="offer_price"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">Offer Price</td>
                    <td class="summary-table-info">
                      <div class="cell-content">
                        <span>{{ 620000 | currency }}</span>
                      </div>
                    </td>
                    <td class="summary-table-title"><span>Notes</span></td>
                    <td class="summary-table-notes"><span></span></td>
                  </tr>
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="escrow_holder"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">Close of Escrow</td>
                    <td class="summary-table-info">30 Days After Acceptance</td>
                    <td></td>
                    <td></td>
                  </tr>
  
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="contingencies"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">Appraisal Contingency</td>
                    <td class="summary-table-info">17</td>
                    <td></td>
                    <td></td>
                  </tr>
  
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" class="contingencies" svgIcon="contigency_loan">
                      </mat-icon>
                    </td>
                    <td class="summary-table-column-title">Loan Contingency</td>
                    <td class="summary-table-info">21</td>
                    <td></td>
                    <td></td>
                  </tr>
  
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="contingencies"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">General Contingency</td>
                    <td class="summary-table-info">17</td>
                    <td></td>
                    <td></td>
                  </tr>
  
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="deposit"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">Deposit</td>
                    <td class="summary-table-info">
                      <div class="cell-content">
                        <span>{{ 18600 | currency }}</span>
                      </div>
                    </td>
                    <td class="summary-table-title"><span>Notes</span></td>
                    <td class="summary-table-notes"><span></span></td>
                  </tr>
  
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="down_payment"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">Down Payment</td>
                    <td class="summary-table-info">
                      <span>
                        {{ 20 }}%
                      </span>
                      <ng-template #currency>
                        {{ 9999 | currency }}
                      </ng-template>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
  
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="lender"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">Lender</td>
                    <td class="summary-table-info">Name of Lender</td>
                    <td></td>
                    <td></td>
                  </tr>
  
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="financing"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">Financing</td>
                    <td class="summary-table-info">{{ 558000 | currency }}</td>
                    <td></td>
                    <td></td>
                  </tr>
  
                  <tr>
                    <td class="summary-table-image">
                      <mat-icon [style.color]="data.headerColor" svgIcon="timer"></mat-icon>
                    </td>
                    <td class="summary-table-column-title">Offer Response Deadline</td>
                    <td class="summary-table-info">{{ 2021/03/27 | date:'mediumDate' }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
  
                <div class="summary-text">
                  <pre>Offer Letter Conclusion</pre>
                </div>
                <div class="summary-signatures">
                  <div class="summary-signature">
                    <div class="image">
                      <div class="image-container" [style.background-image]="'url('+(data.signatureUrl)+')'">
                      </div>
                      <!-- <img [src]="data.offer.realtorOfferSignature" alt="Realtor offer signature"> -->
                    </div>
                    <h5 class="name">{{ data.firstName }} {{data.lastName}}</h5>
                    <p class="hint">Realtor</p>
                  </div>
                  <div class="summary-signature" *ngIf="data.loanOfficer">
                    <div class="image">
                      <div class="image-container"
                        [style.background-image]="'url('+(data.loanOfficer.signatureUrl)+')'"></div>
                    </div>
                    <h5 class="name">{{ data.loanOfficer.firstName }} {{ data.loanOfficer.lastName }}</h5>
                    <p class="hint">Loan Officer</p>
                  </div>
                </div>
              </section>
            </main>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="footer-space">&nbsp;</div>
          </td>
        </tr>
      </tfoot>
    </table>
    <footer [style.backgroundColor]="data.footerColor" class="footer">
      <ul class="footer-info">
        <li>
            {{ data.firstName }} {{data.lastName}}, {{ data.phoneNumber }},
          <a href="mailto:{{ data.email }}">{{ data.email }}</a>
        </li>
        <li>{{ data.officeAddress }}</li>
        <li><a href="{{ data.website }}">{{ data.website }}</a></li>
      </ul>
    </footer>
  </ng-container>